'use client';

import clsx from 'classnames';
import LogoGarneczki from 'icons/lib/garneczki.svg';
import LogoFinesio from 'icons/lib/logo.svg';
import { ComponentProps } from 'react';
import { LOCALE } from 'utils';

import { useCurrentLocale } from '@/shared/utils/client';

import styles from './logo.module.scss';

type LogoProps = {} & ComponentProps<'span'>;

export function Logo({ className, ...props }: LogoProps) {
  const locale = useCurrentLocale();
  const isGarneczki = locale === LOCALE.PL;

  return (
    <span
      className={clsx(styles.root, className, {
        [styles.isGarneczki]: isGarneczki,
      })}
      {...props}
    >
      {isGarneczki ? <LogoGarneczki /> : <LogoFinesio />}
    </span>
  );
}
